var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"padding":"25px","max-width":"100%"},attrs:{"src":("https://api.qrserver.com/v1/create-qr-code/?size=350x350&data=" + (encodeURIComponent(_vm.data))),"width":"400","height":"400"}})}
var staticRenderFns = []

export { render, staticRenderFns }